import {React, useState} from 'react'
import {Link} from 'react-router-dom'

import Logo from './Logo'
import About from '../Pages/About'
import Portfolio from '../Pages/Portfolio'
import UnderConstruction from '../Pages/UnderConstruction'
//import Logo from '../Images/Logo.png'

const navigation = [
    // { name: 'Services', href: '/#services' },
    // { name: 'Testimonials', href: '#' },
    { name: 'About', href: '/about' },
    { name: 'Our Work', href: '/portfolio' },
  ]

function Header() {
    const [mobileMenu, setMobileMenu] = useState(false)

    return (
    <>
    <header className='bg-white/95 backdrop-blur-sm border-b border-slate-200 w-screen sticky top-0 z-50 shadow-sm'>
        <nav className="mx-auto flex items-center justify-between p-4 lg:px-8">
            <Logo />
             <div> {/* Hamburger Menu */}
                <button
                    type="button"
                    onClick={() => setMobileMenu(!mobileMenu)}
                    className='text-3xl align-bottom md:hidden mr-5'
                >&#9776;
                </button>
            </div>
            <div className='hidden md:flex md:flex-row items-center gap-8'>
                <div className="flex items-center gap-6">
                    {navigation.map((item) => (
                        <Link
                            key={item.name}
                            to={item.href}
                            className='text-slate-700 hover:text-blue-600 font-medium transition-colors duration-200 relative group'
                        >
                            {item.name}
                            <span className='absolute inset-x-0 -bottom-1 h-0.5 bg-blue-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-200'></span>
                        </Link>
                    ))}
                </div>
                <div className='w-px h-6 bg-slate-300' />
                <div>
                    <Link
                        to="/contact"
                        className='btn-primary'
                    >
                        Contact Us
                    </Link>
                </div>
            </div>
        </nav>
    </header>
    {/* Mobile Menu - outside header to avoid positioning issues */}
    {mobileMenu && (
        <div className="md:hidden">
            <div className="fixed inset-0 z-50 bg-black/20" onClick={() => setMobileMenu(false)} />
            <div className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                <div className="flex items-center justify-between">
                    <a href="#" className="-m-1.5 p-1.5">
                        <span className="sr-only">Wallace Software Consulting</span>
                        <Logo />
                    </a>
                    <button
                        type="button"
                        onClick={() => setMobileMenu(false)}
                        className="-m-2.5 rounded-md p-2.5 text-gray-700"
                    >
                        <span className="sr-only">Close menu</span>
                        Close
                    </button>
                </div>
                <div className="mt-6 flow-root">
                    <div className="-my-6 divide-y divide-gray-500/10">
                        <div className="space-y-2 py-6">
                            {navigation.map((item) => (
                                <Link
                                    key={item.name}
                                    to={item.href}
                                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                                    onClick={() => setMobileMenu(false)}
                                >
                                    {item.name}
                                </Link>
                            ))}
                        </div>
                        <div className="py-6">
                            <Link
                                to="/contact"
                                className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                                onClick={() => setMobileMenu(false)}
                            >
                                Contact Us
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )}
    </>
  )
}

export default Header